import { Stack } from "@mui/material";
import TourProgramApprovalDesktop from "../components/desktop/tour-program-approval/TourProgramApprovalDesktop";

const TourProgramApproval = () => {
  return (
    <Stack gap={2} m={2}>
      <TourProgramApprovalDesktop />
    </Stack>
  );
};

export default TourProgramApproval;
